<template>
    <h1 class="mb-2 text-3xl font-bold text-[#142b4c]">
        <Link
            class="text-[#45618a] hover:text-[#142b4c]"
            :href="href"
        >
            {{ parentLabel }}
        </Link>

        <span class="font-medium text-[#45618a]"> > </span>
        {{ childLabel }}
    </h1>
    <div class="text-xs mb-8">{{ directLink }}</div>
</template>

<script>
    import { Link } from '@inertiajs/inertia-vue3'

    export default {
        components: {
            Link
        },
        props: {
            href: {
                type: String,
                required: true
            },
            parentLabel: {
                type: String,
                required: true
            },
            childLabel: {
                type: String,
                required: true
            },
            directLink: {
                type: String,
                required: false
            }
        }
    }
</script>